<template>
    <button @click="solicitar()" type="button" class="btn btn-sm btn-success btn-block">
        <i class="fa fa-download"></i> SOLICITAR POSIÇÃO
    </button>
</template>
<script>
    import {Comandos} from "../../class/comandos";
    import {Bus} from '../../class/bus';
    export default {
        props: {
            id_rastreador: {
                "default": null
            }
        },
        methods: {
            async solicitar(){
                await Comandos.solicitarPosicao(this.id_rastreador);
                Bus.$emit('comandos');
            }
        }
    }
</script>
